module.exports = __webpack_public_path__ + "static/media/image-order.aefbbf16.png";